import React, { Component } from "react";
import { View, Text, TouchableOpacity } from "react-native";
import { Data, OrdData, PosData } from "../~Utilities/Data";
import { Connection, ConnectionMkt, ConnectionOrd } from "../~Utilities/Connection";
import Utilities from '../~Utilities/Utilities';
import { Entypo, Feather, FontAwesome5, Foundation, Ionicons, MaterialCommunityIcons, MaterialIcons  } from '@expo/vector-icons';
import { PriceType, TransactionType } from "../~Utilities/Rq";
import { FontAwesome  } from '@expo/vector-icons';
import Text2 from "../C_Text/Text2";
import QB from "./QB";
import TextWithImage from "../C_Text/TextWithImage";
import Order from "../C_Popups/SettingsAndOrders";
import Text3 from "../C_Text/Text3";
import OnlyImage from "../C_Text/OnlyImage";
import { EvtItem, FontInfo } from "../~Utilities/Constants";
import OBNakedStaticStyleText from "../C_Text/OBNakedStaticStyleText";
import Text2EqvEvt from "../C_Text/Text2EqvEvt";

/*   ====================================================================   */

export interface IEVTInfo
{
  oData      : Data;
  oPosData   : PosData | undefined;
  bindEvent  : (onEvent    : (() => void), 
                bSubscribe : boolean) => void,
  

  qbRef?     : React.RefObject<QB>;

  oEvtItem   : EvtItem;
  //GetCallPos : () => PosData | undefined;
  //GetPutPos  : () => PosData | undefined;

  HideOthers   : (dStrike : number | undefined) => void;
  bExclusive   : boolean;
}

/*   ====================================================================   */

interface IEVTInfoState 
  {
  yes_count_total        : number;
  yes_count_working      : number;
  no_count_total         : number;
  no_count_working       : number;

  total_visible          : boolean;
  working_visible        : boolean;

  yes_conf               : boolean;
  no_conf                : boolean;
  yes_exit_conf          : boolean;
  no_exit_conf           : boolean;
  }

/*   ====================================================================   */

export default class EVTInfo extends Component<IEVTInfo>
 {
  private  bUpdateOrder = false;
  private  sExpiry?     : string;
  private  iCount       : number  = 0;
  private  oCallPos     : PosData | undefined;
  private  oPutPos      : PosData | undefined;
  private  oTimeOut?    : NodeJS.Timeout;

  /*   -------------------------------------------------------------------   */

  private static readonly COL_YES = 'limegreen';
  private static readonly COL_NO  = '#FF6461' //#FF6E6B';

  private static readonly COL_YES_CONF = '#64e986';
  private static readonly COL_NO_CONF  = '#FF9694' //#FF6E6B';

  /*   -------------------------------------------------------------------   */

  state : IEVTInfoState = {
                          yes_count_total: 0,
                          yes_count_working: 0,
                          no_count_total: 0,
                          no_count_working: 0,

                          total_visible:true,
                          working_visible:true,

                          yes_conf:false,
                          no_conf:false,

                          yes_exit_conf:false,
                          no_exit_conf:false,
                          }

  /*   -------------------------------------------------------------------   */                          

  constructor(props)
  {
  super(props);

  /*   -------------------------------------------------------------------   */

  if (this.props.oEvtItem.oCallData)
    this.oCallPos = ConnectionOrd.GetPosData(this.props.oEvtItem.oCallData,
                                             this.props.oPosData?.acc_key);

  if (this.props.oEvtItem.oPutData)
    this.oPutPos = ConnectionOrd.GetPosData(this.props.oEvtItem.oPutData,
                                            this.props.oPosData?.acc_key);
                                                                                      

  // Utilities.Sendlog("***CTR *** Event Ctr: " + "acckey: " + this.props.oPosData?.acc_key + 
  //                    " call data: " + this.props.oEvtItem.oCallData?.token + " put data: " + this.props.oEvtItem.oPutData?.token + 
  //                    " call pos: " + this.oCallPos?.token + " put pos: " + this.oPutPos?.token);

  /*   -------------------------------------------------------------------   */                     

  this.UpdateData         = this.UpdateData.bind(this);
  this.PlaceBuy           = this.PlaceBuy.bind(this);
  this.Cancel             = this.Cancel.bind(this);
  this.onOrderEvent       = this.onOrderEvent.bind(this);
  this.GetWOOrders        = this.GetWOOrders.bind(this);
  this.GetCOOrders        = this.GetCOOrders.bind(this);
  this.GetTotalOrderCount = this.GetTotalOrderCount.bind(this);
  this.Reset              = this.Reset.bind(this);
  this.OnConfirmApply     = this.OnConfirmApply.bind(this);
  this.SetPos             = this.SetPos.bind(this);
  this.GetOrdColor        = this.GetOrdColor.bind(this);
  this.GetOrdColorSingle  = this.GetOrdColorSingle.bind(this);

  /*   -------------------------------------------------------------------   */

  let bConfirm : boolean;

  if (this.props.qbRef?.current?.oOrderRef)
    {
    bConfirm = this.props.qbRef?.current?.oOrderRef?.state.confirm_actions;

    
    //this.props.qbRef?.current?.oOrderRef?.ApplySettings(this.OnConfirmApply, true);
    }
  else
    bConfirm = true;


  this.state = {
                yes_count_total: this.oCallPos? this.oCallPos.orders.length : 0,
                yes_count_working: this.oCallPos? this.oCallPos.orders_working.length : 0,

                no_count_total: this.oPutPos? this.oPutPos.orders.length : 0,
                no_count_working: this.oPutPos? this.oPutPos.orders_working.length : 0,

                total_visible:this.props.oEvtItem.total_visible,
                working_visible:this.props.oEvtItem.working_visible,

                yes_conf:!bConfirm,
                no_conf:!bConfirm,

                yes_exit_conf:!bConfirm,
                no_exit_conf:!bConfirm,
                }

  /*   -------------------------------------------------------------------   */                

  }

  /*   -------------------------------------------------------------------   */

  OnConfirmApply(iMsg   : number,
                 bApply : any)
  {
  if (iMsg != Order.MSG_CHANGE_CONFIRM)
    return;
    
  //alert(bApply);
  clearTimeout(this.oTimeOut);
  this.oTimeOut = undefined;

  this.setState({
                yes_conf:!bApply,
                no_conf:!bApply,

                yes_exit_conf:!bApply,
                no_exit_conf:!bApply,
                });
  }

  /*   -------------------------------------------------------------------   */

  componentDidMount() 
  {
  ConnectionOrd.BindEvent(this.onOrderEvent, true);
  this.props.bindEvent(this.UpdateData, true);

  if (this.props.qbRef?.current?.oOrderRef)
    {
    //bConfirm = this.props.qbRef?.current?.oOrderRef?.state.confirm_actions;

    this.props.qbRef?.current?.oOrderRef?.ApplySettings(this.OnConfirmApply, true);
    }
  }

  /*   -------------------------------------------------------------------   */

  componentWillUnmount() 
  {
  ConnectionOrd.BindEvent(this.onOrderEvent, false);
  this.props.bindEvent(this.UpdateData, false);

  if (this.oTimeOut)
    {
    clearTimeout(this.oTimeOut);
    this.oTimeOut = undefined;
    }

  this.props.qbRef?.current?.oOrderRef?.ApplySettings(this.OnConfirmApply, false);
  }

  /*   ------------------------------------------------------------------   */

  componentDidUpdate()
  {
  }

  /*   -------------------------------------------------------------------   */

  onOrderEvent (sToken?    : string,
                oOrdData?  : OrdData,
                oPosData?  : PosData,
                dRemPrice? : number,
                sBasketId? : string)
  {
  if (!sToken)
    return;
    
  if (!oOrdData || !oPosData)
    {
    this.SetPos();

    // if (sToken == this.oCallPos?.token ||
    //     sToken == this.oPutPos?.token)
    //   {
    //   this.bUpdateOrder = true;
    //   }

    return;
    }

  /*   -------------------------------------------------------------------   */

  this.SetPos();

  // Utilities.Sendlog("Event Got Order: " + oOrdData?.basket_id + " " + this.oCallPos?.token + " " + this.oPutPos?.token);

  // if (this.props.oPosData?.acc_key == oPosData.acc_key &&
  //     (this.oCallPos?.token == oPosData.token || 
  //      this.oPutPos?.token  == oPosData.token))
  //   {
  //   Utilities.Sendlog("Event Got Order: " + oOrdData?.basket_id);
  //   this.bUpdateOrder = true;
  //   //this.oLastOrder = oOrdData;
  //   //this.iCount     = 0;
  //   }
  }

  /*   -------------------------------------------------------------------   */

  SetPos()
  {
  if (this.props.oPosData?.acc_key)
    {
    if (this.props.oEvtItem.oCallData && !this.oCallPos)
      {
      this.oCallPos = ConnectionOrd.GetPosData(this.props.oEvtItem.oCallData,
                                               this.props.oPosData?.acc_key);

      //Utilities.Sendlog("Event Got Order & Set Call Pos: " + oOrdData?.basket_id + " " + this.oCallPos?.token + " " + this.oPutPos?.token);
      }

    if (this.props.oEvtItem.oPutData && !this.oPutPos)
      {
      this.oPutPos = ConnectionOrd.GetPosData(this.props.oEvtItem.oPutData,
                                              this.props.oPosData?.acc_key);

      //Utilities.Sendlog("Event Got Order & Set Put Pos: " + oOrdData?.basket_id + " " + this.oCallPos?.token + " " + this.oPutPos?.token);
      }
    }
  }

  /*   -------------------------------------------------------------------   */

  UpdateData()
  {
    let bUpdate = false;

    if (this.oCallPos != undefined)
      {
      if (this.oCallPos.orders_working.length != this.state.yes_count_working ||
          this.oCallPos.orders.length         != this.state.yes_count_total)
          bUpdate = true;
        // this.setState({count_total: this.state.pos_data.orders.length,
        //                count_working: this.state.pos_data.orders_working.length}); 
      }

    if (this.oPutPos != undefined)
      {
      if (this.oPutPos.orders_working.length != this.state.no_count_working ||
          this.oPutPos.orders.length         != this.state.no_count_total)
          bUpdate = true;
        // this.setState({count_total: this.state.pos_data.orders.length,
        //                count_working: this.state.pos_data.orders_working.length}); 
      }    

    if (bUpdate == true) //this.bUpdateOrder == true)
      {
        this.setState({
                       yes_count_total: this.oCallPos? this.oCallPos.orders.length : 0,
                       yes_count_working: this.oCallPos? this.oCallPos.orders_working.length : 0,
                       

                       no_count_total: this.oPutPos? this.oPutPos.orders.length : 0,
                       no_count_working: this.oPutPos? this.oPutPos.orders_working.length : 0,
                       }); 

        //this.bUpdateOrder = false;
        }

    // if (this.oLastOrder)
    //   {
    //   this.iCount++;

    //   //this.forceUpdate();

    //   if (this.iCount > 15)
    //     {
    //     this.iCount     = 0;
    //     this.oLastOrder = undefined;
    //     }
    //   }
  }

  /*   ------------------------------------------------------------------   */

  PlaceBuy(oData      : Data | undefined,
           sToken     : string | undefined,
           sWindowName: string)
  {
  if (Connection.IsOrderAvailable() == false || !sToken)
    {
    this.props.qbRef?.current?.oOrderRef?.ShowNoOrder();  
    return;
    }

  if (!sToken)
    {
    this.props.qbRef?.current?.oOrderRef?.ShowNoOrder("Symbol not available");
    return;
    }

  if (!oData || !oData.ask_size)
    {
    this.props.qbRef?.current?.oOrderRef?.ShowNoOrder("No market");
    return;
    }

  let iQty = this.props.qbRef?.current?.oOrderRef?.state.def_qty_evt;
  
  ConnectionOrd.oConn?.Rq_PlaceOrder(this.props.oPosData?.acc_key, 
                                     sToken, 
                                     TransactionType.BUY, 
                                     iQty? iQty : 1, 
                                     sWindowName,
                                     PriceType.LIMIT,
                                     oData.ask);
}

  /*   ------------------------------------------------------------------   */

  Cancel(oPos        : PosData | undefined,
         sWindowName : string)
  {
  if (Connection.IsOrderAvailable() == false || !oPos)
    {
    this.props.qbRef?.current?.oOrderRef?.ShowNoOrder();  
    return;
    }

  if (__DEV__)
    Utilities.Sendlog("Event Exiting : " + oPos.token);

  if (oPos.net_qty)
    ConnectionOrd.oConn?.Rq_PlaceOrder(this.props.oPosData?.acc_key, 
                                        oPos.token, 
                                        oPos.net_qty < 0? 
                                        TransactionType.BUY : TransactionType.SELL,
                                        Math.abs(oPos.net_qty),
                                        sWindowName,
                                        PriceType.MARKET);
  }

  /*   ------------------------------------------------------------------   */ 

  GetOrdColorSingle(oPos: PosData | undefined)
  {
  if (oPos                       == undefined ||
      oPos.orders_working        == undefined ||
      oPos.orders_working.length == 0)
    return('gainsboro');
  else if (oPos.order_buy_qty && !oPos.order_sell_qty)
     return('dodgerblue');
  else if (!oPos.order_buy_qty && oPos.order_sell_qty)
    return('hotpink');
  else
    return('#9f00ff');
  }

  /*   ---------------------------------------------------------------------   */

  GetOrdColor(oPos1: PosData | undefined, oPos2: PosData | undefined)
  {
  let sCol1 = this.GetOrdColorSingle(oPos1);

  switch(sCol1)
    {
    case 'gainsboro':
      return(this.GetOrdColorSingle(oPos2));
    case 'dodgerblue':
    case 'hotpink':
        let sCol2 = this.GetOrdColorSingle(oPos2);

        if (sCol1 != sCol2)
          return('#9f00ff');
        else
          return(sCol1);
    default:
        return('#9f00ff');
    }
  }

  /*   ---------------------------------------------------------------------   */

  // static GetOrdColor(oPos  : PosData | undefined)
  // {
  // if (oPos?.orders_working        == undefined ||
  //     oPos?.orders_working.length == 0)
  //   return('gainsboro')
  // else
  //    return('darkorange')
  // }

  /*   ---------------------------------------------------------------------   */

  static GetPosColor(oPos  : PosData | undefined, 
                     sCol? : string)
  {
    if (oPos          == undefined ||
        oPos?.net_qty == undefined ||
        oPos?.net_qty == 0)
      return('gainsboro');
    else if (sCol)
      return(sCol);
    else if (oPos?.net_qty > 0)
      return('dodgerblue')
    else
      return('hotpink')

    // else
    //   return(sCol); // '#ff355e');
  }

  /*   ---------------------------------------------------------------------   */

  static GetPosText(oPos : PosData | undefined)
  {
  if (!oPos)
    return("");

  if (oPos?.net_qty || oPos?.closed_pnl)
    return(oPos?.net_qty);
  else
    return("");
  }

  /*   ---------------------------------------------------------------------   */

  static GetPos(oPos : PosData | undefined)
  {
  if (!oPos)
    return;

  if (oPos?.net_qty || oPos?.closed_pnl)
    return(oPos?.net_qty);
  else
    return;
  }

  /*   ---------------------------------------------------------------------   */

  static GetMaxProfit(oData : Data | undefined)
  {
  if (!oData)
    return("$");

  if (!oData.ask_size || !oData.ask) 
    return("$");
  else 
    return("$" + ConnectionMkt.getFmt(100 - oData.ask, oData));
  }

  /*   ---------------------------------------------------------------------   */

  static GetAsk(oData : Data | undefined)
  {
  if (!oData)
    return("$_");

  if (!oData.ask_size) 
    return("$_");
  else 
    return("$" + ConnectionMkt.getFmt(oData.ask, oData));
  }

  /*   ---------------------------------------------------------------------   */

  GetWOOrders()
  {
  let oOrders : string[] = Array(0);

  if (!this.state.working_visible)
    return(oOrders);

  if (this.oCallPos && this.oCallPos.orders_working.length)
    {
    for (let i = 0; i < this.oCallPos.orders_working.length; i++)
      oOrders.push(this.oCallPos.orders_working[i]);
    }

  if (this.oPutPos && this.oPutPos.orders_working.length)
    {
    for (let i = 0; i < this.oPutPos.orders_working.length; i++)
      oOrders.push(this.oPutPos.orders_working[i]);
    }

  return( oOrders.sort((a, b) => b > a? 1 : a > b? -1 : 0 ) );
  }

  /*   ---------------------------------------------------------------------   */

  GetCOOrders()
  {
  let oOrders : string[] = Array(0);

  if (!this.state.total_visible)
    return(oOrders);

  if (this.oCallPos && this.oCallPos.orders.length)
    {
    for (let i = 0; i < this.oCallPos.orders.length; i++)
      oOrders.push(this.oCallPos.orders[i]);
    }

  if (this.oPutPos && this.oPutPos.orders.length)
    {
    for (let i = 0; i < this.oPutPos.orders.length; i++)
      oOrders.push(this.oPutPos.orders[i]);
    }

  return( oOrders.sort((a, b) => b > a? 1 : a > b? -1 : 0 ) );
  }

  /*   ---------------------------------------------------------------------   */

  GetTotalOrderCount()
  {
  let iCount = 0;

  if (this.oCallPos && this.oCallPos.orders.length)
    {
    iCount = this.oCallPos.orders.length;
    }

  if (this.oPutPos && this.oPutPos.orders.length)
    {
    iCount += this.oPutPos.orders.length;
    }

  return( iCount );
  }

  /*   ---------------------------------------------------------------------   */

  static GetPNLText(oPos     : PosData | undefined, 
                    iPnlType : number | undefined)
  {
    if (!oPos)
      return;

    switch(iPnlType)
      {
      case Order.PNL_AUTO:
      default:  
        if (oPos.net_qty)
          return(oPos?.open_pnl);
        else
          return(oPos?.total_pnl);

      case Order.PNL_OPEN:
        return(oPos?.open_pnl);

      case Order.PNL_TOTAL:
        return(oPos?.total_pnl);

      case Order.PNL_OFF:
        return;
      }
  }

  /*   ---------------------------------------------------------------------   */

  static GetPNLColor(oPos     : PosData | undefined, 
                     iPnlType : number | undefined)
  {
  let iPnl : number | undefined;

  if (!oPos)
    return('gainsboro');

  switch(iPnlType)
    {
    case Order.PNL_AUTO:  
    default:
      if (oPos?.net_qty != undefined &&
          oPos?.net_qty != 0)
        {
        iPnl = oPos?.open_pnl;

        if (iPnl == undefined)
          return('gainsboro')
        else if (iPnl >= 0)
          return(FontInfo.sGreen)
        else
          return('red')
        }
      else
        {
        iPnl = oPos?.total_pnl;

        if (iPnl == undefined || !iPnl)
          return('gainsboro')
        else if (iPnl >= 0)
          return(FontInfo.sGreen)
        else
          return('red')
        }
      
    case Order.PNL_OPEN:
        iPnl = oPos?.open_pnl;

        if (iPnl == undefined || !iPnl)
          return('gainsboro')
        else if (iPnl >= 0)
          return(FontInfo.sGreen)
        else
          return('red')

    case Order.PNL_TOTAL:
        iPnl = oPos?.total_pnl;

        if (iPnl == undefined || !iPnl)
          return('gainsboro')
        else if (iPnl >= 0)
          return(FontInfo.sGreen)
        else
          return('red')  
          
    case Order.PNL_OFF:
      return('gainsboro')
    }
  }

  /*   ---------------------------------------------------------------------   */

  Reset()
  {
  if (this.oTimeOut)
    {
    clearTimeout(this.oTimeOut);
    this.oTimeOut = undefined;
    }
  
    this.oTimeOut = setTimeout(() => 
      {
      clearTimeout(this.oTimeOut);        
      this.oTimeOut = undefined;

      this.setState({
                      yes_conf:false,
                      no_conf:false,

                      yes_exit_conf:false,
                      no_exit_conf:false,
                    })
      }, 3000);
  }

  /*   ---------------------------------------------------------------------   */

  render() {
    return (
          <>
          <View style={{alignSelf:'center', flexDirection:'column', width:Utilities.WIDTH - 50, margin:5, marginTop:10, marginBottom:20, padding:0, alignItems:'center', 
                          backgroundColor:FontInfo.sButton, borderRadius:10, paddingVertical:10, paddingTop:15}}>

            <TouchableOpacity style={{position:'absolute', left:0, top:0, paddingVertical:4, paddingHorizontal:7}} 
              onPress={()=>
              {
              let sNavigateToken;

              if (this.props.oEvtItem.sPutToken)
                {
                if (ConnectionMkt.oStore.has(this.props.oEvtItem.sPutToken) == false)                  
                  ConnectionMkt.GetSymbolInfo(this.props.oEvtItem.sPutToken, "add_next " + this.props.oData.token, "");
                else
                  sNavigateToken = this.props.oEvtItem.sPutToken;
                }

              if (this.props.oEvtItem.sCallToken)
                {
                if (ConnectionMkt.oStore.has(this.props.oEvtItem.sCallToken) == false)
                  ConnectionMkt.GetSymbolInfo(this.props.oEvtItem.sCallToken, "add_next " + this.props.oData.token, ""); 
                else
                  sNavigateToken = this.props.oEvtItem.sCallToken;

                if (sNavigateToken)
                  ConnectionOrd.NavigateToToken(sNavigateToken);
                }
              }}>

            {/* <Ionicons name="arrow-redo-circle" size={24} color={FontInfo.sButton2} /> */}
            {/* <Ionicons name="ios-arrow-redo-sharp" size={24} color="gainsboro" /> */}
            <Ionicons name="arrow-redo-circle-outline" size={22} color={FontInfo.sGray} />
            {/* <MaterialIcons name="redo" size={24} color="gainsboro" /> */}
            {/* <FontAwesome name="pagelines" size={24} color="gainsboro" /> */}
            </TouchableOpacity>

            <TouchableOpacity style={{position:'absolute', top:0, right:0, paddingVertical:7, paddingHorizontal:6}}
             onPress={()=>{this.props.HideOthers(this.props.bExclusive? undefined : this.props.oEvtItem.dStrike)}}
             >

            {/* <Ionicons name="ios-eye" size={24} color={this.props.bExclusive? 'skyblue' : 'gray'} /> */}
            {/* <Foundation name="eye" size={24} color={this.props.bExclusive? 'skyblue' : 'gainsboro'} /> */}
            <Entypo name="pin" size={16} color={this.props.bExclusive? 'deepskyblue' : FontInfo.sGray} />
            </TouchableOpacity>

            {/* <Text style={[FontInfo.appStyles.txt_bold, 
                          {fontSize:FontInfo.iFontSize + 2, color:'gray', marginRight:5, marginBottom:5,
                          textAlign:'center'}]}>{this.oEvtData? this.oEvtData.sExpiry : " " }</Text> */}

            {/* Expiry */}
            {/* <Text style={[FontInfo.appStyles.txt_bold, 
                          {fontSize:FontInfo.iFontSize, color:'gray', marginRight:0, marginBottom:2,
                          textAlign:'left'}]}>Betting Closes At {this.oFirstSym?.expiry_time? Utilities.FormatDateAndTimeFromSsboe(this.oFirstSym.expiry_time) : " " }</Text> */}

            {/* <View style={{alignSelf:'center', width:Utilities.WIDTH - 50, flexDirection:'row', marginTop:5}}>
            <Text style={[FontInfo.appStyles.txt_bold, 
                          {fontSize:FontInfo.iFontSize, flex:1, color:'gray', marginRight:0, marginBottom:5,
                          textAlign:'left'}]}>{this.oFirstSym?.expiry_time? Utilities.FormatDateAndTimeFromSsboe(this.oFirstSym.expiry_time) : " " }</Text>
            <Text3 name = "" bbb={this.props.bindEvent} 
                  getstyle={()=>{return([FontInfo.appStyles.txt_bold, {flex:1, marginBottom:5, textAlign:'right',
                                          color: Utilities.getModeColor(!this.oFirstSym? "" : this.oFirstSym.mode)}])}} 
                  ggg={()=>{return(this.oFirstSym?.mode)}}></Text3>
            </View> */}

            {/* Question */}
            <View style={{flexDirection:'row', justifyContent:'center', alignItems:'center', marginTop:10}}>

            <Text style={[FontInfo.appStyles.txt_bold,
                          {fontSize:FontInfo.iFontSize+2, color:FontInfo.sForeground, marginRight:2,
                          textAlign:'center'}]}>Will</Text>
            <Text style={[FontInfo.appStyles.txt_bold,
                          {fontSize:FontInfo.iFontSize+2, color:'limegreen', marginRight:2,
                          textAlign:'center'}]}>{this.props.oData.trading_symbol? this.props.oData.trading_symbol : this.props.oData.symbol}</Text>
            <Text style={[FontInfo.appStyles.txt_bold,
                          {fontSize:FontInfo.iFontSize+2, color:FontInfo.sForeground, 
                          textAlign:'center'}]}>settle  above</Text>

            <Text style={[FontInfo.appStyles.txt_bold,
                          {fontSize:FontInfo.iFontSize+2, color:'limegreen', marginLeft:2,
                          textAlign:'center'}]}>{ConnectionMkt.getFmt(this.props.oEvtItem.dStrike, this.props.oData)}</Text>

            <Text style={[FontInfo.appStyles.txt_bold, {color:FontInfo.sForeground, marginLeft:-5,
                            fontSize:FontInfo.iFontSize+2, textAlign:'center'}]}> ?</Text>

            </View>

            <View style={{width:Utilities.WIDTH - 50, marginTop:16, alignSelf:'center', flexDirection:'row', 
                          justifyContent:'center', alignItems:'center'}}>

            {/* Button - CALL */}
            <View style={{justifyContent:"center", alignItems:'center', marginHorizontal:8}}>

            <Text2 name = "" bbb={this.props.bindEvent} 
                style={[FontInfo.appStyles.txt_bold, {backgroundColor:'transparent', color:EVTInfo.COL_YES, paddingHorizontal:4}]} 
                ggg={()=>{return(EVTInfo.GetMaxProfit(this.props.oEvtItem.oCallData))}}></Text2>

            <Text style={[FontInfo.appStyles.txt_normal, {fontSize:FontInfo.iFontSize-2, color:EVTInfo.COL_YES, margin:2,}]}>Max Profit</Text>
            </View>

            <TouchableOpacity style={{alignContent:'center', backgroundColor:this.state.yes_conf?EVTInfo.COL_YES:FontInfo.sDivider, justifyContent:'center', padding:4, 
                      marginRight:10, alignItems:'center',
                      width:60, height:60, borderRadius:60/2,}} 
                      onPress={()=>{
                                    if (this.state.yes_conf)
                                      {
                                      this.PlaceBuy(this.props.oEvtItem.oCallData, 
                                                    this.props.oEvtItem.sCallToken,
                                                    "Event Trade, Thumb Up Button",);

                                      if (this.props.qbRef?.current?.oOrderRef?.state.confirm_actions)
                                        this.setState({yes_conf:false});
                                      }
                                    else
                                        {
                                         this.setState({yes_conf:true});
                                         this.Reset();
                                         }}}>

              <Text2 name = "" bbb={this.props.bindEvent} 
                style={[FontInfo.appStyles.txt_bold, {backgroundColor:'transparent', color:!this.state.yes_conf?EVTInfo.COL_YES:'white', paddingHorizontal:4}]} 
                ggg={()=>{return(EVTInfo.GetAsk(this.props.oEvtItem.oCallData))}}></Text2>
            <MaterialCommunityIcons name="thumb-up" size={24} color={!this.state.yes_conf?EVTInfo.COL_YES:'white'} />

            </TouchableOpacity>                      

            {/* Button - PUT */}
            <TouchableOpacity style={{alignContent:'center', backgroundColor:this.state.no_conf?EVTInfo.COL_NO:FontInfo.sDivider, justifyContent:'center', padding:4, 
                      marginRight:10, alignItems:'center',
                      width:60, height:60, borderRadius:60/2,}} 
                      onPress={()=>{
                                    if (this.state.no_conf) 
                                      {
                                      this.PlaceBuy(this.props.oEvtItem.oPutData, 
                                                    this.props.oEvtItem.sPutToken,
                                                    "Event Trade, Thumb Down Button",);

                                      if (this.props.qbRef?.current?.oOrderRef?.state.confirm_actions)
                                        this.setState({no_conf:false});
                                      }
                                    else
                                      {
                                      this.setState({no_conf:true});
                                      this.Reset();
                                      }}}>

              <Text2 name = "" bbb={this.props.bindEvent} 
                style={[FontInfo.appStyles.txt_bold, {backgroundColor:'transparent', color:!this.state.no_conf?EVTInfo.COL_NO:'white', paddingHorizontal:4}]} 
                ggg={()=>{return(EVTInfo.GetAsk(this.props.oEvtItem.oPutData))}}></Text2>
            <MaterialCommunityIcons name="thumb-down" size={24} color={!this.state.no_conf?EVTInfo.COL_NO:'white'} />
            </TouchableOpacity>                      

            {/* <TouchableOpacity style={{alignContent:'center', backgroundColor:EVTInfo.COL_NO, justifyContent:'center', padding:4, 
                      alignItems:'center',
                      width:60, height:60, borderRadius:60/2, borderColor:FontInfo.sBorder, borderWidth:0}} 
                      onPress={()=>{this.PlaceBuy(this.props.oEvtItem.sPutToken)}}>
            <Text2 name = "" bbb={this.props.bindEvent} 
                style={[FontInfo.appStyles.txt_bold, {backgroundColor:'transparent', color: 'white', paddingHorizontal:4}]} 
                ggg={()=>{return(EVTInfo.GetAsk(this.props.oEvtItem.oPutData))}}></Text2>
            <MaterialCommunityIcons name="thumb-down" size={24} color="white" />                    
            </TouchableOpacity>                                */}

            <View style={{justifyContent:"center", alignItems:'center', marginHorizontal:8}}>
            <Text2 name = "" bbb={this.props.bindEvent} 
                style={[FontInfo.appStyles.txt_bold, {backgroundColor:'transparent', color:EVTInfo.COL_NO, paddingHorizontal:4}]} 
                ggg={()=>{return(EVTInfo.GetMaxProfit(this.props.oEvtItem.oPutData))}}></Text2>

                <Text style={[FontInfo.appStyles.txt_normal, {fontSize:FontInfo.iFontSize-2, color:EVTInfo.COL_NO, }]}>Max Profit</Text>
            </View>
            </View>

            {/*** P & L ***/}
            <View style={{alignSelf:'center', flexDirection:'row', width:Utilities.WIDTH - 50, alignItems:'center', 
                          alignContent:'center', justifyContent:'center',
                          backgroundColor:'transparent', marginTop:15, marginBottom:5}}>

                  {/* <TouchableOpacity style={{alignItems:'center', justifyContent:'center', flexDirection:'row',
                                        borderRadius:10, padding:5,
                                        backgroundColor:FontInfo.sDivider, marginHorizontal:7}} 
                          onPress={()=>{this.CancelCall(oEvtItem, iIndex)}}>
                  <TextWithImage bindEvent={this.props.bindEvent}
                    onPress={()=>{this.CancelCall(oEvtItem, iIndex)}}
                    Sample_Image={()=>{return(<FontAwesome style={{marginHorizontal:2}} name="close" size={14} color={EVT.GetExitPosColor(this.oCallPos, iIndex)} />)}}
                    getStyle={()=>
                              {
                              return([FontInfo.appStyles.txt_bold, {color: EVT.GetPNLColor(this.oCallPos, iIndex, this.state.qbRef?.current?.oOrderRef?.state.pnl_type), }])
                              }}
                    getText={()=>{return(EVT.GetPNLText(this.oCallPos, iIndex, this.state.qbRef?.current?.oOrderRef?.state.pnl_type))}}
                  />
                  </TouchableOpacity> */}


                {/*** P & L CALL ***/}
                <View style={{backgroundColor:'transparent', width:'50%', alignItems:'flex-end', }}>
                <View style={{alignItems:'center', justifyContent:'center', flexDirection:'row',
                                        borderRadius:10, padding:0, minHeight:30, marginRight:5,
                                        backgroundColor:FontInfo.sDivider, }}>
                    {/* Close */}
                    <TouchableOpacity style={{width:30, minHeight:30, backgroundColor:this.state.yes_exit_conf && EVTInfo.GetPos(this.oCallPos)? '#ff355e' : FontInfo.sButton2, alignItems:'center', 
                                                marginRight:6,
                                                justifyContent:'center', alignContent:'center', borderTopLeftRadius:10, borderBottomLeftRadius:10}}
                    onPress={()=>{
                                  if (this.state.yes_exit_conf)
                                    {
                                    this.Cancel(this.oCallPos, "Event Trade, Exit Thumb Up Button");

                                    if (this.props.qbRef?.current?.oOrderRef?.state.confirm_actions)
                                      this.setState({yes_exit_conf:false});
                                    }
                                  else
                                    {
                                    if (EVTInfo.GetPos(this.oCallPos)) 
                                      {
                                      this.setState({yes_exit_conf:true});
                                      this.Reset();
                                      }
                                    }}}>

                    <OnlyImage bindEvent={this.props.bindEvent}
                    Sample_Image={()=>{return(<FontAwesome style={{}} name="close" size={14} color={this.state.yes_exit_conf && EVTInfo.GetPos(this.oCallPos)? 'white' : EVTInfo.GetPosColor(this.oCallPos, '#ff355e')} /> )}}
                    getText={()=>{return(EVTInfo.GetPosText(this.oCallPos))}}
                    />
                    </TouchableOpacity>

                    {/* PNL */}
                    <TextWithImage bindEvent={this.props.bindEvent}
                    Sample_Image={()=>{return(
                        <Foundation name="dollar" size={18} color={EVTInfo.GetPNLColor(this.oCallPos, this.props.qbRef?.current?.oOrderRef?.state.pnl_type)} />)}}
                    getStyle={()=>
                              {
                              return([FontInfo.appStyles.txt_bold, {marginRight:5, color: EVTInfo.GetPNLColor(this.oCallPos, this.props.qbRef?.current?.oOrderRef?.state.pnl_type), }])
                              }}
                    getText={()=>{return(EVTInfo.GetPNLText(this.oCallPos, this.props.qbRef?.current?.oOrderRef?.state.pnl_type))}}
                    />

                    {/* Position */}
                    <TextWithImage bindEvent={this.props.bindEvent}
                      Sample_Image={()=>{return(<FontAwesome5 style={{marginTop:-2}} name="shopping-bag" size={12} 
                                                 color={EVTInfo.GetPosColor(this.oCallPos)} />)}}
                      getStyle={()=>{return([FontInfo.appStyles.txt_bold, {marginRight:5, color:EVTInfo.GetPosColor(this.oCallPos), }])}}
                      getText={()=>{return(EVTInfo.GetPosText(this.oCallPos))}}
                    />

                    {/* WO */}
                  {/* <TextWithImage bindEvent={this.props.bindEvent}
                    Sample_Image={()=>{return(<Feather style={{}} name="shopping-cart" size={12} color={EVTInfo.GetOrdColor(this.oCallPos)} />)}}
                    getStyle={()=>{ return([FontInfo.appStyles.txt_bold, {color:EVTInfo.GetOrdColor(this.oCallPos)}]
                    )}}
                  getText={()=>{return(  this.oCallPos?.net_qty == undefined? "" : this.oCallPos.orders_working.length.toString())}}
                  /> */}

                </View>
                </View>


                {/*** P & L PUT ***/}
                <View style={{backgroundColor:'transparent', width:'50%', alignItems:'flex-start', }}>
                <View style={{alignItems:'center', justifyContent:'center', flexDirection:'row',
                                        borderRadius:10, padding:0, minHeight:30, marginLeft:8,
                                        backgroundColor:FontInfo.sDivider, }}>

                    {/* WO */}
                    {/* <TextWithImage bindEvent={this.props.bindEvent}
                      Sample_Image={()=>{return(<Feather style={{marginLeft:5}} name="shopping-cart" size={12} color={EVTInfo.GetOrdColor(this.oPutPos)} />)}}
                      getStyle={()=>{ return([FontInfo.appStyles.txt_bold, {color:EVTInfo.GetOrdColor(this.oPutPos)}]
                      )}}
                      getText={()=>{return(  this.oPutPos?.net_qty == undefined? "" : this.oPutPos.orders_working.length.toString())}}
                      /> */}

                    {/* Position */}
                    <TextWithImage bindEvent={this.props.bindEvent}
                      Sample_Image={()=>{return(<FontAwesome5 style={{marginLeft:13, marginTop:-2}} name="shopping-bag" size={12} color={EVTInfo.GetPosColor(this.oPutPos)} />)}}
                      getStyle={()=>{return([FontInfo.appStyles.txt_bold, {marginRight:5, color: EVTInfo.GetPosColor(this.oPutPos), }])}}
                      getText={()=>{return(EVTInfo.GetPosText(this.oPutPos))}}
                    />

                    {/* PNL */}
                    <TextWithImage bindEvent={this.props.bindEvent}
                    Sample_Image={()=>{return(
                        <Foundation name="dollar" size={18} color={EVTInfo.GetPNLColor(this.oPutPos, this.props.qbRef?.current?.oOrderRef?.state.pnl_type)} />)}}
                    getStyle={()=>
                              {
                              return([FontInfo.appStyles.txt_bold, {marginRight:0, color: EVTInfo.GetPNLColor(this.oPutPos, this.props.qbRef?.current?.oOrderRef?.state.pnl_type), }])
                              }}
                    getText={()=>{return(EVTInfo.GetPNLText(this.oPutPos, this.props.qbRef?.current?.oOrderRef?.state.pnl_type))}}
                    />

                    {/* Close */}
                    <TouchableOpacity style={{width:30, minHeight:30, backgroundColor:this.state.no_exit_conf && EVTInfo.GetPos(this.oPutPos)? '#ff355e' : FontInfo.sButton2, alignItems:'center', justifyContent:'center', alignContent:'center', borderTopRightRadius:10, borderBottomRightRadius:10}}
                    onPress={()=>{
                                  if (this.state.no_exit_conf)
                                    {
                                    this.Cancel(this.oPutPos, "Event Trade, Exit Thumb Down Button");

                                    if (this.props.qbRef?.current?.oOrderRef?.state.confirm_actions)
                                      this.setState({no_exit_conf:false});
                                    }
                                  else
                                    {
                                    if (EVTInfo.GetPos(this.oPutPos)) 
                                      {
                                      this.setState({no_exit_conf:true});
                                      this.Reset();
                                      }}}}>

                    <OnlyImage bindEvent={this.props.bindEvent}
                    Sample_Image={()=>{return(<FontAwesome style={{}} name="close" size={14} color={this.state.no_exit_conf && EVTInfo.GetPos(this.oPutPos)? 'white' : EVTInfo.GetPosColor(this.oPutPos, '#ff355e')} /> )}}
                    getText={()=>{return(EVTInfo.GetPosText(this.oPutPos))}}
                    />
                    </TouchableOpacity>

                </View>
                </View>
                  
            </View>


            <Text3 name = "" bbb={this.props.bindEvent} 
                  getstyle={()=>{return([FontInfo.appStyles.txt_bold, {marginTop:5, textAlign:'right',
                                          color: Utilities.getModeColor(this.props.oEvtItem.oCallData?.mode)}])}} 
                  ggg={()=>{return(this.props.oEvtItem.oCallData?.mode)}}></Text3>

            <Text2EqvEvt 
                exp_time={this.props.oEvtItem.oCallData?.expiry_time}
                style={[FontInfo.appStyles.txt_normal, 
                        {fontSize:FontInfo.iFontSize, color:'gray', marginRight:0, marginBottom:5,
                        textAlign:'left'}]} 
                getText={()=>{return(this.props.oEvtItem.oCallData?.mode)}} 
                bindEvent={this.props.bindEvent}>
            </Text2EqvEvt>      

            {/* <Text style={[FontInfo.appStyles.txt_normal, 
                          {fontSize:FontInfo.iFontSize, color:'gray', marginRight:0, marginBottom:5,
                           textAlign:'left'}]}
                  >Trading {this.props.oData.mode && (this.props.oData.mode.toLowerCase() == "expired" || this.props.oData.mode.toLowerCase() == "end of day")? "closed" : "closes"} at {this.props.oEvtItem.oCallData?.expiry_time? Utilities.FormatTimeFromSsboe(this.props.oEvtItem.oCallData.expiry_time) + " on " + Utilities.FormatDateFromSsboe(this.props.oEvtItem.oCallData.expiry_time) : " " }</Text> */}

              {/* {
              oEvtItem.oOrders.map((oEventOrder)=>
                {
                  return(
                  <View style={{alignSelf:'center', flexDirection:'row', width:Utilities.WIDTH - 50, marginTop:5, padding:0, 
                               alignItems:'center', justifyContent:'center', backgroundColor:FontInfo.sButton, borderRadius:10}}>
                    <View style={{alignSelf:'center', flexDirection:'row', borderRadius:10, alignItems:'center', backgroundColor:'transparent'}}>
                      <MaterialCommunityIcons name={oEventOrder.bUp? "thumb-up" : "thumb-down"} size={14} color={oEventOrder.bUp? 'dodgerblue' : 'hotpink'} />
                      <Text style={[FontInfo.appStyles.txt_bold, {color:oEventOrder.bUp? 'gray' : 'gray', marginHorizontal:5}]}> filled @Market</Text>
                    </View>
                  </View>
                  );

                })
              } */}


              </View>


              {/* <Text3 name = "" bbb={this.props.bindEvent} 
                  getstyle={()=>{return([FontInfo.appStyles.txt_normal, 
                                         {marginTop:5, 
                                          color: 'gray'}])}} 
                  ggg={()=>{return(!this.oLastOrder? "" : this.oLastOrder?.basket_id + "-" + this.oLastOrder?.status + " - " + this.oLastOrder?.completion_reason + " - " + this.oLastOrder?.remarks)}}></Text3> */}

            {/* <ScrollView contentContainerStyle={{backgroundColor:'transparent', alignItems:'center', justifyContent:'center'}}> */}

            <TouchableOpacity style={this.GetTotalOrderCount()==0? {display:'none'} :
              {flexDirection:'row', width:210, margin:10, marginTop:-10, paddingHorizontal:8, paddingVertical:4, alignItems:'center', backgroundColor:FontInfo.sButton, borderRadius:10}}
             onPress={()=>{ this.props.oEvtItem.working_visible = !this.state.working_visible; this.setState({working_visible:!this.state.working_visible}); }}
             >
            <MaterialIcons name={'expand-more'} style={{alignSelf:'flex-end'}} size={24} color={this.state.working_visible? 'deepskyblue' : "gainsboro"} />
            <Text style={[FontInfo.appStyles.txt_bold, {color:FontInfo.sForeground, fontSize:FontInfo.iFontSize + 2, minWidth:120, marginLeft:10, textAlign:'center', backgroundColor:'transparent' }]}>Working Orders</Text>

            <View style={(this.state.yes_count_working + this.state.no_count_working) == 0? {backgroundColor:'grey', marginLeft:10, marginRight:5, borderRadius:5} : {backgroundColor:this.state.yes_count_working + this.state.no_count_working? 'darkorange' : 'gainsboro', marginLeft:10, marginRight:5, borderRadius:5}}>
            <Text style={[FontInfo.appStyles.txt_bold, {color:'white', paddingHorizontal:4, textAlign:'center'}]}>{(this.state.yes_count_working + this.state.no_count_working)}</Text>
            </View>
            </TouchableOpacity>

            <View>
            {
              this.GetWOOrders().map((basket_id) => 
                {
                let oOrdData = Connection.oOrdStore.get(basket_id);

                if (oOrdData == undefined)
                  return(null);

                const getThumbCol = () => {
                                       if (oOrdData == undefined) return("transparent");

                                       if (oOrdData.txn_type_api == TransactionType.BUY)
                                        {
                                        if (oOrdData.token == this.oCallPos?.token)
                                          return(EVTInfo.COL_YES);
                                        else
                                          return(EVTInfo.COL_NO);
                                        }

                                       return('transparent');
                                       }

                const getThumbName = () => {
                                       if (oOrdData == undefined) return("thumb-up");

                                       if (oOrdData.txn_type_api == TransactionType.BUY)
                                        {
                                        if (oOrdData.token == this.oCallPos?.token)
                                          return('thumb-up');
                                        else
                                          return('thumb-down');
                                        }

                                       return('thumb-up');
                                       }

                const getStatus = () => {return(oOrdData? oOrdData.status : "")};

                const getOrder  = () => {if (oOrdData == undefined) return("empty");
                                        else
                                        {
                                        //  let sPrice = "";
                                        
                                        //  if (oOrdData.price_type_api == PriceType.STOP_LIMIT ||
                                        //      oOrdData.price_type_api == PriceType.STOP_MARKET)
                                        //      sPrice = ConnectionMkt.getFmtWithPad(oOrdData.trigger_price, this.props.oData, " @");
                                        //  else if (oOrdData.price_type_api == PriceType.LIMIT)
                                        //      sPrice = ConnectionMkt.getFmtWithPad(oOrdData.limit_price, this.props.oData, " @");

                                            
                                        return(oOrdData.txn_type + " " + 
                                                oOrdData.qty + " " + 
                                                oOrdData.price_type + 
                                                getPrice()); 
                                        };
                                      };

                const getPrice = () => {if (oOrdData == undefined) return("empty");
                                        else
                                        {
                                        let sPrice = "";
                                        
                                        if (oOrdData.price_type_api == PriceType.STOP_LIMIT ||
                                            oOrdData.price_type_api == PriceType.STOP_MARKET)
                                            sPrice = ConnectionMkt.getFmtWithPad(oOrdData.trigger_price, this.props.oData, " @");
                                        else if (oOrdData.price_type_api == PriceType.LIMIT)
                                            sPrice = ConnectionMkt.getFmtWithPad(oOrdData.limit_price, this.props.oData, " @");

                                        return(sPrice);
                                        };
                                      };

                const cancelOrder = () => {if (oOrdData == undefined) return;
                                        else
                                        {
                                        ConnectionOrd.oConn?.Rq_CancelOrder(oOrdData.acc_key, 
                                                                            oOrdData.basket_id,
                                                                            "Event Trade, Cancel Button",);  
                                        }
                                        };  
                                        
                                                //!oOrdData.limit_price? "" : "@" + ConnectionMkt.getFmt(oOrdData.limit_price? oOrdData.limit_price : 0, this.props.oData) ); };
                
                return(
                      <View key={basket_id} style={{width:Utilities.WIDTH - 50, margin:10, marginTop:0, padding:8, alignItems:'center', justifyContent:'center', backgroundColor:FontInfo.sButton, borderRadius:10}}>
                        <View style={{flexDirection:'row'}}>
                        <MaterialCommunityIcons name={getThumbName()} style={{display:getThumbCol()=='transparent'?'none':'flex'}} size={14} color={getThumbCol()} />
                        <Text style={[FontInfo.appStyles.txt_bold, {marginLeft:4, color:'slategrey', alignSelf:'center'}]}>{oOrdData.basket_id}</Text>
                        </View>

                        <TouchableOpacity style={{alignItems:'center', justifyContent:'center', borderBottomLeftRadius:10, borderTopLeftRadius:10, position:'absolute', backgroundColor:FontInfo.sDivider, top:0, left:0, bottom:0, width:30}} 
                          onPress={()=>{cancelOrder()}}>
                        {/* <AntDesign name="closecircle" size={30} color="#ef3038" /> */}
                        <FontAwesome style={{marginLeft:2}} name="close" size={20} color="#ff355e" />
                        </TouchableOpacity>

                        <View style={oOrdData.txn_type == "Buy"? {borderRadius:5, backgroundColor:'dodgerblue'} : {borderRadius:5, backgroundColor:'hotpink'}}>
                          <OBNakedStaticStyleText
                            style={[FontInfo.appStyles.txt_bold, {color:'white', marginHorizontal:4}]} 
                            getText={getOrder}
                            bindEvent={this.props.bindEvent}
                          />
                        {/* <Text style={{color:'white', fontSize:12, marginHorizontal:4, fontWeight:'bold'}}>{oOrdData.txn_type} {oOrdData.qty} {oOrdData.price_type} {oOrdData.limit_price? "@" + ConnectionMkt.getFmt(oOrdData.limit_price, this.props.oData) : ""}</Text> */}
                        </View>

                        <OBNakedStaticStyleText 
                          style={[FontInfo.appStyles.txt_bold, {color:FontInfo.sGreen}]} 
                          getText={getStatus}
                          bindEvent={this.props.bindEvent}
                        />

                      </View>
                      );
                })
            }
            </View>

            <TouchableOpacity style={this.GetTotalOrderCount()==0? {display:'none'} :
              {flexDirection:'row', width:210, margin:10, marginTop:0, paddingHorizontal:8, paddingVertical:4, alignItems:'center', backgroundColor:FontInfo.sButton, borderRadius:10}}
              onPress={()=>{ this.props.oEvtItem.total_visible = !this.state.total_visible; this.setState({total_visible:!this.state.total_visible}); }}
            >
            {/* <View style={{position:'absolute', top:0, right:2, marginVertical:8, alignItems:'center', justifyContent:'center'}}> */}
            <MaterialIcons name={'expand-more'} style={{alignSelf:'flex-end'}} size={24} color={this.state.total_visible? 'deepskyblue' : "gainsboro"} />
            {/* </View> */}

            <Text style={[FontInfo.appStyles.txt_bold, {color:FontInfo.sForeground, fontSize:FontInfo.iFontSize + 2, minWidth:120, marginLeft:10, textAlign:'center', backgroundColor:'transparent' }]}>Completed</Text>

            <View style={{backgroundColor:'grey', marginLeft:10, borderRadius:5, marginRight:5, }}>
            <Text style={[FontInfo.appStyles.txt_bold, {color:'white', paddingHorizontal:4}]}>{((this.state.yes_count_total + this.state.no_count_total) - (this.state.yes_count_working + this.state.no_count_working))}</Text>
            </View>
            </TouchableOpacity>

            {/* <View style={{width:200, margin:10, padding:8, alignItems:'center', justifyContent:'center', backgroundColor:'#f5f6fa', borderRadius:10}}>
            <Text style={{fontWeight:'bold', color:'black'}}>Completed Orders {this.state.count_total - this.state.count_working}</Text>
            </View> */}

            <View>
              {
              this.GetCOOrders().map((basket_id) => 
                {
                const getThumbCol = () => {
                                       if (oOrdData == undefined) return("transparent");

                                       if (oOrdData.txn_type_api == TransactionType.BUY)
                                        {
                                        if (oOrdData.token == this.oCallPos?.token)
                                          return(EVTInfo.COL_YES);
                                        else
                                          return(EVTInfo.COL_NO);
                                        }

                                       return('transparent');
                                       }

                const getThumbName = () => {
                                       if (oOrdData == undefined) return("thumb-up");

                                       if (oOrdData.txn_type_api == TransactionType.BUY)
                                        {
                                        if (oOrdData.token == this.oCallPos?.token)
                                          return('thumb-up');
                                        else
                                          return('thumb-down');
                                        }

                                       return('thumb-up');
                                       }

                const getPrice = () => {if (oOrdData == undefined) return("empty");
                                        else
                                        {
                                        let sPrice = "";
                                        
                                        if (oOrdData.price_type_api == PriceType.STOP_LIMIT ||
                                            oOrdData.price_type_api == PriceType.STOP_MARKET)
                                            sPrice = ConnectionMkt.getFmtWithPad(oOrdData.trigger_price, this.props.oData, " @");
                                        else if (oOrdData.price_type_api == PriceType.LIMIT)
                                            sPrice = ConnectionMkt.getFmtWithPad(oOrdData.limit_price, this.props.oData, " @");

                                        return(sPrice);
                                        };
                                      };                                 

                let oOrdData = Connection.oOrdStore.get(basket_id);

                if (oOrdData == undefined || oOrdData.status != "complete")
                  return(null);

                return(
                      <View key={basket_id} style={{width:Utilities.WIDTH - 50, margin:10, marginTop:0, padding:8, alignItems:'center', justifyContent:'center', backgroundColor:FontInfo.sButton, borderRadius:10}}>
                      {/* <View style={{backgroundColor:'#f5f6fa', borderTopEndRadius:10, borderTopStartRadius:10, }}>
                      <Text style={{fontSize:12, color:'black', marginTop:4, alignSelf:'center', fontWeight:'bold'}}>{oOrdData.basket_id}</Text>
                      </View> */}

                      {/* <View style={{padding:8, alignItems:'center', justifyContent:'center', borderBottomLeftRadius:10, borderBottomRightRadius:10, backgroundColor:'#f5f6fa'}}> */}

                        <View style={{flexDirection:'row'}}>
                        <MaterialCommunityIcons name={getThumbName()} style={{display:getThumbCol()=='transparent'?'none':'flex'}} size={14} color={getThumbCol()} />
                        <Text style={[FontInfo.appStyles.txt_normal, {color:'slategrey', alignSelf:'center'}]}>{oOrdData.basket_id}</Text>
                        </View>

                        <View style={oOrdData.completion_reason=="filled"? (oOrdData.txn_type == "Buy"? {borderRadius:5, backgroundColor:'dodgerblue'} : {borderRadius:5, backgroundColor:'hotpink'}) : {borderRadius:5, backgroundColor:'grey'}}>
                        <Text style={[FontInfo.appStyles.txt_normal, {color:'white', marginHorizontal:4, }]}>{oOrdData.txn_type} {oOrdData.qty} {oOrdData.price_type} {getPrice()}</Text>
                        </View>

                        {/* <View style={{flexDirection:'row'}}> */}
                        <Text style={[FontInfo.appStyles.txt_normal, {color:'slategrey'}]}>{oOrdData.completion_reason} {oOrdData.fill_price? "@" + ConnectionMkt.getFmt(oOrdData.fill_price, this.props.oData) : ""}</Text>

                        <Text style={oOrdData.remarks? [FontInfo.appStyles.txt_normal, {textAlign:'center', color:'slategrey', flexWrap:'wrap'}] : {display:'none'}}>{oOrdData.remarks}</Text>
                        {/* </View> */}

                      {/* </View> */}
                      </View>
                      );
                })
              }
            </View>
            {/* </ScrollView> */}


              </>
    );
  }
}